import combineClassNames from './combine-class-names'

export default combineClassNames
